import { Alert, Button, Flex, Form } from "antd";
import { useTranslation } from "react-i18next";

import { NewPasswordFields } from "../shared/NewPasswordFields";

interface Props {
  error: string;
  onCancel: () => void;
  onSubmit: (values: { newPassword: string }) => void;
}

export const NewPasswordForm = ({ error, onSubmit, onCancel }: Props) => {
  const { t } = useTranslation(["common"]);

  return (
    <Form<{ newPassword: string; confirmPassword: string }>
      onFinish={onSubmit}
      layout="vertical"
    >
      <Flex vertical gap="middle">
        {error && <Alert type="error" title={error} showIcon />}

        <NewPasswordFields />

        <Form.Item>
          <Button type="primary" htmlType="submit" block size="large">
            {t("passwordLogin.setPassword")}
          </Button>
        </Form.Item>

        <Button type="link" block onClick={onCancel}>
          {t("idpDiscovery.useDifferentEmail")}
        </Button>
      </Flex>
    </Form>
  );
};
